export class Url {
  static PARK4NIGHT_ULOZ_MISTA = "/ajax/ajax-uloz-json-park4night-places.php";
  static VRAT_MISTA_JSON = "/ajax/ajax-json-vrat-mista.php";
  static ULOZ_VLASTNI_MISTO_JSON = "/ajax/ajax-uloz-json-vlastni-misto.php";

  // 🔖 nové pro štítky u míst:
  //static STITKY_MIST_SEARCH = "/ajax/ajax-json-stitky-mist-search.php";
  static STITKY_MIST_ADD = "/ajax/ajax-uloz-json-stitky-mist-add.php";
  static STITKY_MIST_DELETE = "/ajax/ajax-smaz-json-stitky-mist-delete.php";
}
